import {createI18n} from '@soopkr-fe/soop-i18n';
import '@soopkr-fe/soop-i18n/channel';

const i18n = createI18n({
  namespaces: ['channel'],
});

export const ChannelT = i18n.t;
export const ChannelI18n = i18n;

/**
 * 국제화 처리 시 1등, 2등, 3등에 대한 예외처리
 * @param index 등수
 * @returns
 */
export const gradeOrderI18nHelper = (index: number) => {
  if (index === 1) {
    return ChannelT('1등');
  } else if (index === 2) {
    return ChannelT('2등');
  } else if (index === 3) {
    return ChannelT('3등');
  }

  return ChannelT(`{{index}}등`, {placeholder: {index: index}});
};
